<div class="gm-assignment-am-container">
  <h2>GM Assignment Management</h2>
  <p class="desc">Assign, update, or remove General Managers for your managed tenants.</p>

  <!-- Filters Row: Search, Market Area, Assignment Status -->
  <div class="filters-row">
    <!-- Tenant Search Bar (Reactive Form) -->
    <input type="text" [formControl]="tenantSearchControl" placeholder="Search tenants..." />
    <!-- Market Area Filter -->
    <select [formControl]="marketAreaControl">
      <option value="all">All Market Areas</option>
      <option *ngFor="let area of marketAreas" [value]="area">{{ area }}</option>
    </select>
    <!-- Assignment Status Filter -->
    <select [formControl]="assignmentStatusControl">
      <option *ngFor="let opt of assignmentStatusOptions" [value]="opt.value">{{ opt.label }}</option>
    </select>
  </div>

  <div *ngIf="isLoading" class="loading">Loading...</div>
  <div *ngIf="error.tenants" class="error">{{ error.tenants }}</div>

  <!-- Tenants Table -->
  <table *ngIf="!isLoading && filteredTenantRows.length" class="gm-table">
    <thead>
      <tr>
        <th>Tenant</th>
        <th>Market Area</th>
        <th>Assigned GMs</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of filteredTenantRows">
        <td>{{ getTenantName(row.tenant) }}</td>
        <td>{{ row.tenant.marketAreaName }}</td>
        <td>
          <div *ngIf="row.gms.length; else noGm">
            <div *ngFor="let gm of row.gms">
              <span>{{ getGMName(gm) }}</span>
              <!-- Assignment Type Badge -->
              <span class="assignment-type-badge" [ngClass]="getAssignmentTypeClass(gm.assignmentType)">
                {{ getAssignmentTypeLabel(gm.assignmentType) }}
              </span>
              <!-- Workload Badge -->
              <span class="gm-workload-badge" *ngIf="gm._id">{{ getGMWorkloadLabel(gm._id) }}</span>
              <span class="assignment-status" [ngClass]="{ 'active': !gm.endDate, 'inactive': !!gm.endDate }">
                {{ gm.endDate ? 'Inactive' : 'Active' }}
              </span>
              <button (click)="openRemoveModal(gm)">Remove</button>
              <button (click)="openHistoryModal(gm)">History</button>
            </div>
          </div>
          <ng-template #noGm>
            <span>Unassigned</span>
          </ng-template>
        </td>
        <td>
          <button (click)="openAssignmentModal(row)">Assign GM</button>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="!isLoading && !filteredTenantRows.length" class="empty">No tenants found.</div>

  <!-- Assign GM Modal -->
  <div *ngIf="showAssignmentModal" class="modal-backdrop">
    <div class="modal">
      <h3>Assign GM</h3>
      <form [formGroup]="assignmentForm" (ngSubmit)="submitAssignment()">
        <!-- GM Search (Reactive Form) -->
        <label for="gmSearch">Search GM</label>
        <input id="gmSearch" type="text" [formControl]="gmSearchControl" placeholder="Search GMs..." />
        <label for="gmSelect">Select GM</label>
        <select id="gmSelect" formControlName="gmUserId">
          <option value="" disabled>Select a GM</option>
          <option *ngFor="let gm of filteredGMs" [value]="gm._id">
            {{ gm.name }} ({{ gm.email }})
            <ng-container *ngIf="gm._id">- {{ getGMWorkloadLabel(gm._id) }}</ng-container>
          </option>
        </select>
        <label for="assignmentType">Assignment Type</label>
        <select id="assignmentType" formControlName="assignmentType">
          <option value="permanent">Permanent</option>
          <option value="temporary">Temporary</option>
          <option value="backup">Backup</option>
          <option value="support">Support</option>
        </select>
        <label for="reason">Reason</label>
        <input id="reason" type="text" formControlName="reason" placeholder="Reason (optional)" />
        <label for="notes">Notes</label>
        <input id="notes" type="text" formControlName="notes" placeholder="Notes (optional)" />
        <label for="endDate">End Date</label>
        <input id="endDate" type="date" formControlName="endDate" />
        <div *ngIf="error.action" class="error">{{ error.action }}</div>
        <div class="modal-actions">
          <button type="button" (click)="closeAssignmentModal()">Cancel</button>
          <button type="submit" [disabled]="assignmentForm.invalid || isLoadingAction">Save</button>
        </div>
      </form>
    </div>
  </div>

  <!-- Remove Confirmation Modal -->
  <div *ngIf="showConfirmModal" class="modal-backdrop">
    <div class="modal">
      <h3>Remove GM Assignment</h3>
      <p>Are you sure you want to remove this GM assignment?</p>
      <div class="modal-actions">
        <button type="button" (click)="showConfirmModal = false">Cancel</button>
        <button type="button" (click)="executeRemoveAssignment()" [disabled]="isLoadingAction">Remove</button>
      </div>
    </div>
  </div>

  <!-- History Modal (placeholder) -->
  <div *ngIf="showHistoryModal" class="modal-backdrop">
    <div class="modal">
      <h3>Assignment History</h3>
      <div *ngIf="isLoadingHistory">Loading history...</div>
      <div *ngIf="!isLoadingHistory">(History feature coming soon)</div>
      <div class="modal-actions">
        <button type="button" (click)="closeHistoryModal()">Close</button>
      </div>
    </div>
  </div>
</div>
